<template>
    <div class="scrollable-table" :class="containerClass">
        
        <rea-loader :loading="loading"></rea-loader>

        <table class="table table-bordered table__heading">
            <thead>
                <slot name="header"/>
            </thead>
            <slot name="body"/>
        </table>

        <transition name="fade">
            <table class="table table-bordered move__table" v-show="!loading">
                <thead class="ghost-head">
                    <slot name="header"/>
                </thead>
                <slot name="body"/>
            </table>
        </transition>
    </div>
</template>

<script>
    import ReaLoader from "../../helpers/rea-loader"

    export default {
        name: 'ScrollableSecondTable',
        components: { ReaLoader },
        props: {
            containerClass: {
                type: String,
                required: false,
                default: 'plain-card'
            },
            loading: {
                type: Boolean,
                required: false,
                default: false,
            }
        },
    }
</script>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .scrollable-table {
        background-color: white;
        padding: 20px;
        position: relative;
        box-shadow: 3px 1px 5px #ccc;
        &:not(:first-child) {
            margin-top: 30px;
        }
        h2 {
            margin-bottom: 20px;
        }
        table {
            width: 100%;
            max-height: 60vh;
            overflow-y: scroll;
            display: block;
        }
    }

    .move__table {
        transform: translate(0px, -13px);
    }

    .table__heading {
        height: auto !important;
        z-index: 10;
        position: relative;
        background-color: white;
    }

    .table__heading tbody {
        opacity: 0;
        border: 0 none;
        height: 0;
        visibility: collapse;
        * {
            margin: 0;
            padding: 0;
            border: 0 none;
            height: 0;
        }
    }
    .ghost-head {
        opacity: 0;
        border: 0 none;
        height: 0;
        visibility: collapse;
        * {
            margin: 0;
            padding: 0;
            border: 0 none;
            height: 0;
        }
    }
</style>
